import { IRectangle } from 'framework/utils/math-utils';
import { HexGridType } from 'js/bubbleCore/types';
import { getHexSize } from 'js/bubbleCore/utils/getHexSize';
import { isPointyTop } from 'js/bubbleCore/utils/isPointyTop'

export function convertHexLimitsToSpaceLimits<T>(
  limits: IRectangle,
  type: HexGridType,
): IRectangle {
  const result = {...limits};

  const {width: hexWidth, height: hexHeight} = getHexSize(type);

  result.width -= 1;
  result.height -= 1;

  // because hexes are not on top of each other
  if (isPointyTop(type)) {
    result.width *= hexWidth;
    result.height *= hexHeight * 3/4;  
  } else {
    result.width *= hexWidth * 3/4;
    result.height *= hexHeight;
  }

  return result;
}
